import React from "react";
import { List, ListItem, ListItemButton, ListItemText, Divider, Box } from "@mui/material";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

const menuItems = [{ text: "HealthX", icon: <LocalHospitalIcon />, id: "health" }];

const SchedulerxSidebar = ({ selectedPage, handleNavigation }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", backgroundColor: "#282c34", paddingTop: "20px" }}>
            <Divider />
            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: 3, alignItems: "center", justifyContent: "center" }}>
                <List sx={{ width: "100%" }}>
                    {menuItems.map((item) => (
                        <ListItem key={item.id} disablePadding>
                            <ListItemButton
                                onClick={() => handleNavigation(item.id)}
                                sx={{
                                    backgroundColor: selectedPage === item.id ? "#7044ff" : "transparent",
                                    color: selectedPage === item.id ? "white" : "#94A3B8",
                                    "&:hover": { backgroundColor: "#7044ff", color: "white" },
                                    borderRadius: "8px",
                                    marginY: 1,
                                    width: "80%",
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <Box sx={{ color: selectedPage === item.id ? "white" : "#94A3B8", display: "flex", alignItems: "center", gap: 1 }}>
                                    {item.icon}
                                    <ListItemText primary={item.text} sx={{ textAlign: "center" }} />
                                </Box>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Divider />
        </Box>
    );
};

export default SchedulerxSidebar;
